// XOR mask shared with the payment frontend — both sides must use the same value
const XOR_MASK = 0x9e3779b9;

export function encodeOrderId(numericId: number): string {
  const masked = ((numericId ^ XOR_MASK) >>> 0).toString(16).padStart(8, "0");
  const extra = (numericId * 0x517cc1b7 >>> 0).toString(16).padStart(12, "0");
  return `${masked}-0000-4f72-8f72-${extra}`;
}

export function decodeOrderId(encoded: string): number {
  const hex = encoded.split("-")[0];
  return (parseInt(hex, 16) ^ XOR_MASK) >>> 0;
}
